module.exports = __webpack_public_path__ + "static/media/graph.5a6160c1.webp";